import React from "react";
import { PropTypes } from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as dataActions from "../../../../../utils/data/dataActions";
import { CLASSES, DIVISIONS, MEMBERS_GRAPHQL } from "../../../../../utils/data/models";
import * as premiumSimulatorActions from "./premiumSimulatorActions";
import PremiumSimulatorFormContainer from "./PremiumSimulatorFormContainer";
import PremiumSimulatorResults from "./results";
import {
    buildGraphQLQueryParams,
    toGraphQLFormat,
    toGraphQLSortFormat,
} from "../../../../common/GraphQL/GraphQLQueryHelper";

class PremiumSimulatorPage extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.loadDivisions = this.loadDivisions.bind(this);
        this.loadClasses = this.loadClasses.bind(this);
        this.loadMembers = this.loadMembers.bind(this);

    }
    componentDidMount() {
        this.props.dataActions.clearDataList(CLASSES);
        this.props.dataActions.clearDataList(DIVISIONS);
        this.props.dataActions.clearDataList(MEMBERS_GRAPHQL);

        this.loadDivisions();
        this.loadClasses();
        this.loadMembers();
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.clientId !== this.props.clientId) {
            this.props.dataActions.clearDataList(CLASSES);
            this.props.dataActions.clearDataList(DIVISIONS);
            this.props.dataActions.clearDataList(MEMBERS_GRAPHQL);
            this.props.premiumSimulatorActions.clear(nextProps.clientId);

            this.loadDivisions();
            this.loadClasses();
            this.loadMembers();
        }
    }

    componentWillUnmount() {
        const { dataActions, premiumSimulatorActions } = this.props;
        dataActions.clearDataList(CLASSES);
        dataActions.clearDataList(DIVISIONS);
        dataActions.clearDataList(MEMBERS_GRAPHQL);
        premiumSimulatorActions.clear(this.props.clientId);

    }

    loadDivisions() {
        this.props.dataActions.getDataList(
            DIVISIONS,
            0,
            0,
            "",
            ["name:asc"],
            [`divisions.clientId==${this.props.clientId}`, DIVISIONS.archiveFilter]
        );
    }

    loadClasses() {
        this.props.dataActions.getDataList(
            CLASSES,
            0,
            0,
            "",
            ["name:asc"],
            [`classes.clientId==${this.props.clientId}`, CLASSES.archiveFilter]
        );
    }

    loadMembers() {
        const colsStr = `
                memberId
                firstName
                lastName
                provinceCode
                memberIdentifier
                birthdate
                isInternational
                memberCoverages {
                  endDate,
                  isInactive,
                  classId,
                  divisionId,
                  salary,
                  memberCoverageGuarantees {
                    coverageType
                    ageOfPolicyExpiration
                    ageOfPolicyDecrease
                    allowance
                    invoicedClientRate
                    volume
                    formulaMspa
                    guarantee {
                        guaranteeId
                        forDependents
                        localizations
                        guaranteeType
                        isMaster
                        isDrivingMandatoryDependentGuarantee
                  }
                }
    }
        `;
        let filters = [`members.clientId==${this.props.clientId}`, MEMBERS_GRAPHQL.archiveFilter];
        filters = toGraphQLFormat(filters);
        let sortBy = ["members.firstName:asc", "members.lastName:asc"];
        sortBy = toGraphQLSortFormat(sortBy, true);
        const limit = 1000;
        const graphQLQuery = buildGraphQLQueryParams("members", filters, sortBy, 0, limit, colsStr, "getMembers");
        this.props.dataActions.getGraphQL(MEMBERS_GRAPHQL, { query: graphQLQuery }, sortBy);
    }
    render() {
        return (
            <div className="subcontent premiumSimulator">
                <PremiumSimulatorFormContainer />
                <PremiumSimulatorResults />
            </div>
        );
    }
}

PremiumSimulatorPage.propTypes = {
    clientId: PropTypes.number,
    dataActions: PropTypes.object,
    premiumSimulatorActions: PropTypes.object,
};

const mapStateToProps = (state) => {
    const clientId = state.data.clients.active.clientId;
    return {
        clientId: clientId
    };
};

const mapDispatchToProps = (dispatch) => ({
    dataActions: bindActionCreators(dataActions, dispatch),
    premiumSimulatorActions: bindActionCreators(premiumSimulatorActions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(PremiumSimulatorPage);



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/premiumSimulator/PremiumSimulatorPage.js